export default __webpack_public_path__ + "images/PS.7889e68.png";